import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="mb-10 md:mb-16">

            <div className="container px-4 mx-auto">
                {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                    <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                        <div className={"toppartner-new-" + groupIndex} key={groupIndex}>
                            {/* Название */}
                            <h3 className="font-bold text-center uppercase text-[24px] sm:text-[26px] text-[#000] mb-3">{partners_top_status}</h3>

                            {/* Лого */}
                            <div className="flex flex-col sm:flex-row justify-center items-center flex-wrap gap-6">
                                {partners_top_item.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                                    <a
                                        key={`${groupIndex}-${partnerIndex}`}
                                        href={p_url ? p_url : '/'}
                                        className={"text-center block p-2 toppartner-count-" + partnerIndex}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            src={p_thumbnail}
                                            alt={partners_top_status}
                                            className="inline-block object-contain"
                                        />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </ScrollAnimation>
                ))}
            </div>

        </section>
    );
};

export default PartnersTopNew;